import { sanitize } from "@/utils/sanitize";
import { ProgramCardProps } from "@/utils/types";
import Link from "next/link";
import { ImageObject } from "./ImageObject";

export const ProgramCard = async ({
  className,
  componentId,
  logo,
  heading,
  links,
  themeColor = "tertiary",
  subheading,
  description,
}: ProgramCardProps) => {
  const bgClasses: { [key: string]: string } = {
    tertiary: "bg-tertiary",
    primary: "bg-primary",
    primaryDark: "bg-primaryDark",
    secondary: "bg-secondary",
    quaternary: "bg-quaternary",
  };

  const textClasses: { [key: string]: string } = {
    tertiary: "text-primaryDark",
    primary: "text-white",
    primaryDark: "text-white",
    secondary: "text-secondaryDark",
    quaternary: "text-tertiary",
  };

  const headingClasses: { [key: string]: string } = {
    tertiary: "text-primaryDark",
    primary: "text-primaryDark",
    primaryDark: "text-secondary",
    secondary: "text-secondaryDark",
    quaternary: "text-tertiary",
  };

  const buttonClasses: { [key: string]: string } = {
    tertiary: "primary dark",
    primary: "tertiary",
    primaryDark: "secondary",
    secondary: "secondary dark",
    quaternary: "tertiary",
  };

  return (
    <div
      id={componentId}
      className={`programCard w-full md:max-w-[492px] rounded-[24px] md:rounded-card pb-[45px] px-4 md:px-[65px] pt-[65px] flex flex-col gap-6 text-center justify-center items-center overflow-hidden ${themeColor ? bgClasses[sanitize(themeColor)] : ""}${className ? ` ${className}` : ""}`}
    >
      {logo && (
        <ImageObject
          {...logo}
          imageWidth={500}
          alt={`${heading} Logo`}
          className="w-full px-4 md:px-0 max-w-[345px]"
        />
      )}

      <p
        className={`uppercase font-extrabold leading-[1.2] text-[19px] mt-2 ${themeColor ? headingClasses[sanitize(themeColor)] : ""}`}
      >
        {subheading}
      </p>
      <p
        className={`${themeColor ? textClasses[sanitize(themeColor)] : ""} font-semibold px-8 md:px-0 text-pretty`}
      >
        {description}
      </p>

      {links && (
        <div className="flex flex-col sm:flex-row gap-4">
          {links.map((link) => {
            const isExternal = link.link.startsWith("http");
            return (
              <Link
                key={link._key}
                href={link.link}
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noreferrer noopener" : undefined}
                className={`button ${buttonClasses[sanitize(themeColor)]}`}
              >
                {link.copy || "Learn More"}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};
